import React from "react";
import { Button as ButtonBase } from "@stardust-ds/react";

import styles from './index.module.scss';
import PlusIcon from "../../../assets/icons/PlusIcon";
import ArrowLeftIcon from "../../../assets/icons/ArrowLeftIcon";
import ArrowRightIcon from "../../../assets/icons/ArrowRightIcon";
import CheckIcon from "../../../assets/icons/CheckIcon";
import PenDocumentIcon from "../../../assets/icons/PenDocument";
import RcmpAutomationIcon from "../../../assets/icons/AutomationIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";

const GetIcon = ({ icon, ...props }) => {
    switch (icon) {
        case "plus":
            return <PlusIcon {...props} />
        case "arrowLeft":
            return <ArrowLeftIcon {...props} />
        case "arrowRight":
            return <ArrowRightIcon {...props} />
        case "check":
            return <CheckIcon {...props} />
        case "penDocumentIcon":
            return <PenDocumentIcon {...props} />
        case "RcmpAutomationIcon":
            return <RcmpAutomationIcon scale={"1.7"} {...props} />
        case "search":
            return <SearchIcon {...props} />
        default:
            return icon || null;
    }
}

export default function Button(props) {
    const { children, variant = "primary", className, iconLeft, iconRight, liquid = false, stableIcon=false, style, ...rest } = props;

    const liquidWidth = !liquid ? { minWidth: 171 } : "";
    const classes = `${styles.buttonBase} ${styles[variant]} ${className} ${stableIcon ? "" : styles.unstableIcon}`;

    const setIconLeft = iconLeft ? <GetIcon icon={iconLeft} /> : null;
    const setIconRight = iconRight ? <GetIcon icon={iconRight} /> : null;

    return (
        <ButtonBase
            className={classes}
            iconLeft={setIconLeft}
            iconRight={setIconRight}
            style={{ ...liquidWidth, ...style }}
            {...rest}
        >
            {children}
        </ButtonBase>
    )
}